var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "125.000000pt",
    height: "122.000000pt",
    viewBox: "0 0 125.000000 122.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,122.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 1204 c-25 -7 -54 -14 -65 -14 -46 0 -188 -92 -240 -154 -33 -40 -59 -87 -99 -179 -12 -27 -16 -69 -16 -152 0 -118 0 -119 57 -244 31 -68 121 -159 198 -201 75 -40 205 -74 260 -66 85 12 165 32 177 44 6 6 19 12 27 12 9 0 25 7 35 15 11 8 26 15 34 15 7 0 72 -59 143 -130 70 -72 140 -135 155 -140 21 -8 35 -6 63 8 33 17 36 23 39 69 l3 51 -131 130 c-71 72 -130 138 -130 147 0 9 16 50 35 91 35 74 36 79 36 198 0 90 -4 130 -16 152 -8 16 -15 34 -15 41 0 46 -126 199 -192 234 -82 43 -120 59 -184 73 -86 19 -115 19 -174 0z m210 -199 c25 -13 54 -28 66 -34 22 -10 71 -68 95 -111 7 -14 21 -54 30 -90 16 -61 16 -69 0 -130 -29 -112 -74 -174 -165 -225 -59 -33 -68 -35 -156 -35 -88 0 -97 2 -156 35 -57 32 -124 98 -124 123 0 5 -7 15 -15 22 -8 7 -15 27 -16 44 0 17 -6 47 -13 66 -11 29 -11 42 0 74 8 21 14 49 14 61 0 29 57 117 94 146 15 12 51 34 79 50 46 25 62 29 137 29 71 0 92 -4 130 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.71258c1a2cd0096fd99717f484ec7a00.svg";
export { ForwardRef as ReactComponent };